document.addEventListener("DOMContentLoaded", () => {
  const track = document.querySelector(".app-slider-track");
  const slides = document.querySelectorAll(".app-slide");
  const prevBtn = document.querySelector(".app-slider-btn.prev");
  const nextBtn = document.querySelector(".app-slider-btn.next");
  let currentIndex = 0;

  function updateSlider() {
    const slideWidth = slides[0].clientWidth;
    track.style.transform = `translateX(-${currentIndex * slideWidth}px)`;
  }

  if (track) {
  if (prevBtn) {
  // --- Button Events ---
  prevBtn.addEventListener("click", () => {
    currentIndex = (currentIndex - 1 + slides.length) % slides.length;
    updateSlider();
  });
  }

  if (nextBtn) {
  nextBtn.addEventListener("click", () => {
    currentIndex = (currentIndex + 1) % slides.length;
    updateSlider();
  });
  }

  // --- Swipe Events ---
  let startX = 0;
  let endX = 0;

  track.addEventListener("touchstart", (e) => {
    startX = e.touches[0].clientX;
  });

  track.addEventListener("touchmove", (e) => {
    endX = e.touches[0].clientX;
  });

  track.addEventListener("touchend", () => {
    const diff = endX - startX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) {
        // Swipe nach rechts
        currentIndex = (currentIndex - 1 + slides.length) % slides.length;
      } else {
        // Swipe nach links
        currentIndex = (currentIndex + 1) % slides.length;
      }
      updateSlider();
    }
    startX = 0;
    endX = 0;
  });

  window.addEventListener("resize", updateSlider);
  updateSlider();
  }
});
